import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Mid-century Input — single charcoal 1.5px boundary that color-shifts
 * to orange on focus. No layered ring; matches the rest of the design
 * vocabulary (cards, buttons, pills) and keeps focus state legible
 * without doubling the visible line.
 *
 * Height matches Button default (h-10).
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-11 w-full rounded-card border-[1.5px] border-charcoal bg-cream px-3 py-2',
          'text-[16px] font-sans text-charcoal',
          'placeholder:text-charcoal-soft/60',
          'transition-colors',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-charcoal',
          'focus:outline-none focus-visible:outline-none focus-visible:border-orange',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
